@if (items().length) {
  <section [class]="{ 'sheyda-row': true, 'show-row': showRow() }">
    <div class="sheyda-row-header">
      <div class="title-bar-title">
        <h2>
          @if (RowTitleLink()) {
            <a [routerLink]="RowTitleLink()" [title]="RowTitle()">{{ RowTitle() }}</a>
          } @else {
            {{ RowTitle() }}
          }
        </h2>
        @if (RowTitleLink()) {
          <div class="show-full" (click)="handleTitleClick()">
            <span>مشاهده بیشتر</span>
            <mat-icon>chevron_left</mat-icon>
          </div>
        }
      </div>
      @if (RowTitleLink()) {
        <div class="show-full-mobile" (click)="handleTitleClick()">
          <span>مشاهده بیشتر</span>
          <mat-icon>chevron_left</mat-icon>
        </div>
      }
    </div>
    <div class="navigation-wrapper">
      @if (generalService.isSmallScreen()) {
        <div class="mobile-slider">
          @for (item of items(); track $index) {
            <app-sheyda-program-card ViewType="carousel" [Item]="item" class="mobile-slider-item" />
          }
        </div>
      } @else {
        <div class="desktop-slider">
          <div class="keen-slider keen-slider--vertical" #desktopSliderRef>
            @for (item of items(); track $index) {
              <app-sheyda-program-card ViewType="carousel" [Item]="item" class="keen-slider__slide" />
            }
          </div>
          @if (items().length > itemsPerView()) {
            <button
              aria-label="right"
              (click)="prevSlide()"
              [disabled]="currentSlide() === 0"
              [class]="{ 'navigation-button': true, 'prev-slide-button': true, __disabled: currentSlide() === 0 }"
            >
              <mat-icon>chevron_right</mat-icon>
            </button>
            <button
              aria-label="left"
              (click)="nextSlide()"
              [disabled]="items().length - itemsPerView() === currentSlide()"
              [class]="{
                'navigation-button': true,
                'next-slide-button': true,
                __disabled: items().length - itemsPerView() === currentSlide(),
              }"
            >
              <mat-icon>chevron_left</mat-icon>
            </button>
          }
        </div>
      }
    </div>
  </section>
}
